<style scoped>
.market {
  background: #f7f7f7;
  width: 100%;
  height: 100%;
}
li {
  list-style: none;
}
.top {
  color: #333333;
  font-size: 0.17rem;
  position: relative;
}
.banner_box {
  padding-left: 0.15rem;
  padding-right: 0.15rem;
  /* background: #fff; */
  /* margin-bottom: 0.15rem; */
  display: flex;
  justify-content: space-between;
}
.bg_img {
  display: inline-block;
  width: 100%;
  height: 0.29rem;
  background: url('../../assets/img/newpage/bg_img.png') no-repeat center center;
  background-size: 100%;
  position: absolute;
  top: 0.77rem;
}
.hot_list {
  margin-bottom: 0.14rem;
}
.banner,
.hot_list {
  clear: both;
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  padding: 0.11rem 0.2rem;
  background: #fff;
  /* position: relative;
  top: -0.36rem; */
  width: 100%;
  padding-top: 0.22rem;
}
.banner li {
  width: 0.7rem;
  height: auto;
  font-size: 0.13rem;
  color: #333333;
  text-align: center;
  line-height: 15px;
}
.icon1,
.icon2,
.icon3,
.icon4 {
  display: inline-block;
  width: 0.7rem;
  height: 0.6rem;
  border-radius: 50%;
}
.title {
  color: #333333;
  font-size: 0.16rem;
  margin-left: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.line {
  display: inline-block;
  width: 3px;
  height: 12px;
  background: rgba(80, 109, 246, 1);
  margin-right: 5px;
}
.line_bot {
  display: inline-block;
  width: 0.64rem;
  height: 0.08rem;
  background: #ff302b;
  position: absolute;
  bottom: 0;
}
.title_txt {
  z-index: 1;
}
.hot_list {
  margin: 0.2rem 0.1rem;
}
.hot_list li {
  flex: 1;
  border-bottom: 1px solid #eee;
  position: relative;
  /* padding-left: 0.1rem; */
  flex: 0.49;
}
.line_box {
  background: #eeeeee;
  margin-bottom: 0.1rem;
}
.li_line {
  display: inline-block;
  width: 1%;
  height: 100%;
  background: #eee;
  margin-bottom: 0.1rem;
}
.box .con {
  margin-left: 0.1rem;
  width: 57%;
}
.box li.noPad {
  padding-left: 0;
  margin-right: 0.1rem;
}
.box .time {
  font-size: 0.18rem;
  color: #333;
  display: inline-block;
  font-weight: bold;
  /* position: absolute; */
  top: 0.41rem;
  left: 43%;
  /* left: 50%;
  transform: translate(-50%, 0.04rem); */
}
.box .money {
  color: #ff514a;
  font-size: 0.18rem;
  font-weight: bold;
  text-align: left;
  display: inline-block;
  /* width: 55%; */
}
.box .tag {
  color: #999;
  font-size: 0.12rem;
  width: 0.56rem;
  height: 0.18rem;
  text-align: center;
  line-height: 0.18rem;
  display: inline-block;
  background: #ebebeb;
  border-radius: 2px;
  margin-left: 0.1rem;
}
.box .name {
  color: #333333;
  font-size: 0.14rem;
}
.box .logo {
  display: inline-block;
  /* width: 0.38rem;
  height: 0.38rem; */
  width: 0.32rem;
  height: 0.32rem;
  background: url('../../assets/img/newpage/icon3.png') no-repeat center center;
  background-size: 100%;
  /* position: relative; */
  top: 0.03rem;
  border-radius: 4px;
}
.box .repayment {
  height: 0.15rem;
  position: relative;
  top: 0.02rem;
  /* float: right; */
}
.box .hot,
.box .limit,
.box .lowinterest,
.box .largernum,
.box .brand {
  color: #ff0000;
  font-size: 0.12rem;
  background: #ffe3e3;
  padding: 0.01rem 0.02rem;
  float: right;
  right: 0;
  border-radius: 2px;
}
.box .limit {
  color: rgba(255, 172, 72, 1);
  background: rgba(255, 241, 212, 1);
}
.box .lowinterest {
  color: #339999;
  background: #d3f4f4;
}
.box .brand {
  color: #663399;
  background: #eddbff;
}
.box .largernum {
  color: #ffe9da;
  background: #ff6600;
}
.m1 {
  margin-left: 0.1rem;
}
.list {
  position: relative;
  /* background: #fff; */
  padding-top: 0.15rem;
}
.right_img {
  background: url('../../assets/img/newpage/right_img.png') no-repeat center
    center;
  background-size: 100%;
  width: 0.14rem;
  height: 0.14rem;
  display: inline-block;
  float: right;
  position: relative;
  top: 0.15rem;
}
.banner_box img {
  /* background: url("../../assets/img/newpage/banner.png") no-repeat center center; */
  /* background-size: 100%; */
  /* width: 1.67rem; */
  width: 48.5%;
  height: 0.93rem;
  border-radius: 0.05rem;
}
.box {
  width: 100%;
  clear: both;
  overflow: hidden;
}
.box .item {
  width: 100%;
  padding: 0 0.15rem;
  clear: both;
  overflow: hidden;
  background: #fff;
  margin-top: 0.12rem;
  /* height: 1rem; */
}
.border {
  /* border-bottom: 1px solid #eee; */
  clear: both;
  overflow: hidden;
  /* height: 0.75rem; */
  padding: 0.15rem 0;
  position: relative;
}
.border_top {
  border-bottom: 1px solid #eee;
  clear: both;
  overflow: hidden;
  padding: 0.15rem;
  position: relative;
}
.noBorder {
  border-right: none;
}
.apply_btn {
  color: #fff;
  font-size: 0.14rem;
  font-weight: bold;
  text-align: right;
  display: inline-block;
  width: 0.94rem;
  top: 0.08rem;
  background: linear-gradient(90deg, #ff5726 0%, #ff302b 100%);
  box-shadow: 0 0.06rem 0.1rem 0 rgba(228, 238, 250, 1);
  border-radius: 0.15rem;
  height: 0.32rem;
  line-height: 0.32rem;
  text-align: center;
  float: right;
}
.apply_btn_margin {
  margin-top: -0.4rem;
}
.new_apply_btn {
  border-radius: 0.15rem;
  color: #333333;
  background: #ffb82b;
}
.apply_btn_act {
  border-radius: 15px;
  border: 1px solid rgba(79, 140, 250, 1);
  color: #4f8cfa;
  background: #fff;
}
.list_top {
  display: flex;
  align-items: center;
}
.list_context {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.12rem;
  margin-left: 0.38rem;
}
.list_context_top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 0.12rem;
}
.list_name {
  font-size: 0.18rem;
  font-weight: bold;
  color: #333333;
  margin-left: 0.06rem;
}
.list_money_tips {
  color: #666666;
  font-size: 0.12rem;
}
.list_month_tips {
  color: #666666;
  font-size: 0.12rem;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.task_img {
  width: 2.55rem;
  height: auto;
}
.task_close_img {
  width: 0.3rem;
  height: auto;
  margin-top: 0.4rem;
}
.task {
  display: flex;
  flex-direction: column;
  align-items: center;
}
>>> .van-overlay {
  background-color: rgba(0, 0, 0, 0.4);
}
/*  */
.apply_top {
  padding: 0.15rem;
}
.apply_box {
  width: 100%;
  background: #fff;
  border-radius: 0.08rem;
  padding: 0.16rem;
}
.apply_title {
  font-size: 0.14rem;
  font-weight: 500;
  color: #333333;
}
>>> .van-cell {
  align-items: center;
  font-size: 0.48rem;
  padding: 0.05rem 0;
}
>>> .van-field__label {
  width: 0.5rem;
}
>>> .van-field__control {
  /*font-size: 0.36rem;*/
}
>>> .van-field__control::-webkit-input-placeholder {
  color: #999999;
  font-size: 0.36rem;
}
.btn_apply {
  height: 0.5rem;
  background: linear-gradient(90deg, #ff5726 0%, #ff302b 100%);
  border-radius: 0.04rem;
  margin-top: 0.12rem;
  color: #ffffff;
  text-align: center;
  line-height: 0.5rem;
  opacity: 0.5;
  margin-bottom: 0.08rem;
}
.can_click_btn {
  opacity: 1;
}
.product_box {
  width: 100%;
  height: 1.2rem;
  background: #fff;
  border-radius: 0.08rem;
  position: relative;
}
.apply_top_icon {
  background: url('../../assets/img/newpage/apply_top_icon.png') no-repeat top
    center;
  background-size: 100% 100%;
  position: absolute;
  width: 1.1rem;
  height: 0.32rem;
  right: 0;
  top: 0;
  font-size: 0.12rem;
  font-weight: 600;
  color: #2b6bff;
  text-align: center;
  line-height: 0.32rem;
  padding-left: 0.25rem;
}
</style>
<template>
  <div class="market"
       style="height:100%;">
    <div id="mescroll"
         class="mescroll noticeBox"
         ref="mescroll">
      <div>
        <div class="top">
          <div class="top_money">
            <div class="apply_top">
              <div class="apply_box"
                   v-if="showBtn">
                <span class="apply_title">输入您的期望贷款金额（元）</span>
                <van-field v-model="number"
                           type="number"
                           label="¥"
                           @input="applyNum"
                           placeholder="输入金额" />
                <div class="btn_apply"
                     :class="{'can_click_btn':ifClick}"
                     @click="toApplyPage">一键申请</div>
              </div>
              <div class="product_box box"
                   v-if="productDetails[0]&&!showBtn">
                <div class="apply_top_icon">AI智能推荐</div>
                <div class="border_top"
                     @click="listClick(productDetails[0], 2)">
                  <div class="list_top">
                    <img :src="productDetails[0].icon"
                         alt=""
                         class="logo" />
                    <span class="list_name">{{ productDetails[0].name }}
                      <img v-if="productDetails[0].hasPass != 0 && productDetails[0].hasMember"
                           class="repayment"
                           :src="productDetails[0].tagUrls[0]"
                           alt="" />
                      <img v-if="productDetails[0].hasPass && !productDetails[0].hasMember"
                           class="repayment"
                           src="@/assets/img/newpage/img_hydx.png"
                           alt="" />
                      <span class="tag"
                            v-if="productDetails[0].hasPass == 0">资质不符</span>
                    </span>
                  </div>

                  <div class="list_context_top">
                    <div style="min-width:1.1rem;">
                      <p class="list_money_tips">额度(元)</p>
                      <p class="money">{{ productDetails[0].limit }}</p>
                    </div>
                    <div style="min-width:1.1rem;">
                      <p class="list_month_tips">{{ productDetails[0].lendingCycle }}</p>
                      <p class="time">
                        {{ productDetails[0].timeLimit }}
                      </p>
                    </div>
                    <p class="apply_btn"
                       :class="{ new_apply_btn: !productDetails[0].hasMember }"
                       v-if="productDetails[0].hasPass != 0">
                      {{ productDetails[0].hasMember ? "立即申请" : "立即解锁" }}
                    </p>
                    <p v-if="productDetails[0].hasPass == 0"
                       class="apply_btn"
                       :class="{ apply_btn_act: productDetails[0].hasPass == 0 }">
                      查询原因
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- ---- -->
            <div class="banner_box"
                 v-if="status == 1">
              <img :src="imgUrl"
                   @click="bannerClick"
                   alt="" />
              <img :src="moreImgUrl"
                   @click="bannerClickMore"
                   alt="" />
            </div>
            <!-- ---- -->
            <div class="list">
              <div class="title">
                <!-- <span class="line"></span> -->
                <span class="line_bot"></span>
                <span class="title_txt">精准推荐</span>
              </div>
              <div v-if="!showBtn"
                   class="box"
                   id="noticeList"
                   ref="noticeList">
                <div class="item"
                     v-for="(item, idx) in productDetails.slice(1,productDetails.size)"
                     :key="idx"
                     :class="{ noBorder: idx % 2 == 0 }"
                     @click="listClick(item, 2)">
                  <div class="border">
                    <div class="list_top">
                      <img :src="item.icon"
                           alt=""
                           class="logo" />
                      <span class="list_name">{{ item.name }}
                        <img v-if="item.hasPass != 0 && item.hasMember"
                             class="repayment"
                             :src="item.tagUrls[0]"
                             alt="" />
                        <img v-if="item.hasPass && !item.hasMember"
                             class="repayment"
                             src="@/assets/img/newpage/img_hydx.png"
                             alt="" />
                        <span class="tag"
                              v-if="item.hasPass == 0">资质不符</span>
                      </span>
                    </div>

                    <div class="list_context">
                      <div style="min-width:1.1rem;">
                        <p class="list_money_tips">额度(元)</p>
                        <p class="money">{{ item.limit }}</p>
                      </div>
                      <div style="min-width:1.1rem;">
                        <p class="list_month_tips">{{ item.lendingCycle }}</p>
                        <p class="time">
                          {{ item.timeLimit }}
                        </p>
                      </div>
                      <p class="apply_btn apply_btn_margin"
                         :class="{ new_apply_btn: !item.hasMember }"
                         v-if="item.hasPass != 0">
                        {{ item.hasMember ? "立即申请" : "立即解锁" }}
                      </p>
                      <p v-if="item.hasPass == 0"
                         class="apply_btn"
                         :class="{ apply_btn_act: item.hasPass == 0 }">
                        查询原因
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="showBtn"
                   class="box"
                   id="noticeList"
                   ref="noticeList">
                <div class="item"
                     v-for="(item, idx) in productDetails"
                     :key="idx"
                     :class="{ noBorder: idx % 2 == 0 }"
                     @click="listClick(item, 2)">
                  <div class="border">
                    <div class="list_top">
                      <img :src="item.icon"
                           alt=""
                           class="logo" />
                      <span class="list_name">{{ item.name }}
                        <img v-if="item.hasPass != 0 && item.hasMember"
                             class="repayment"
                             :src="item.tagUrls[0]"
                             alt="" />
                        <img v-if="item.hasPass && !item.hasMember"
                             class="repayment"
                             src="@/assets/img/newpage/img_hydx.png"
                             alt="" />
                        <span class="tag"
                              v-if="item.hasPass == 0">资质不符</span>
                      </span>
                    </div>

                    <div class="list_context">
                      <div style="min-width:1.1rem;">
                        <p class="list_money_tips">额度(元)</p>
                        <p class="money">{{ item.limit }}</p>
                      </div>
                      <div style="min-width:1.1rem;">
                        <p class="list_month_tips">{{ item.lendingCycle }}</p>
                        <p class="time">
                          {{ item.timeLimit }}
                        </p>
                      </div>
                      <p class="apply_btn apply_btn_margin"
                         :class="{ new_apply_btn: !item.hasMember }"
                         v-if="item.hasPass != 0">
                        {{ item.hasMember ? "立即申请" : "立即解锁" }}
                      </p>
                      <p v-if="item.hasPass == 0"
                         class="apply_btn"
                         :class="{ apply_btn_act: item.hasPass == 0 }">
                        查询原因
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-overlay :show="show"
                 @click="show = false">
      <div class="wrapper">
        <div class="task">
          <img @click.stop="tomember"
               class="task_img"
               src="@/assets/img/newpage/img_tc_2.png"
               alt="" />
          <img class="task_close_img"
               src="@/assets/img/vip/icon_close.png"
               alt="" />
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import MeScroll from "mescroll.js";
import "mescroll.js/mescroll.min.css";
export default {
  name: "market",
  components: {
    MeScroll,
  },
  data () {
    return {
      oldScrollTop: 0, //记录上一次滚动结束后的滚动距离
      scrollTop: 0, // 记录当前的滚动距离
      noticeScrollTop: "",
      title: "新口子",
      payType: 1,
      lineType: 1,
      appAdvertisementResp: "",
      appRecommendResps: [], //热门区域
      productDetails: [], //分页数据列表
      imgUrl: "",
      moreImgUrl: "",
      json: {},
      status: "",
      showEmpty: false, //是否展示分页
      page: 1,
      pageSize: 20,
      getWindowHeight: "",
      t1: 0,
      t2: 0,
      timer: null,
      productIds: "",
      productTypes: "",
      obj: {
        productId: "",
        sign: "",
      },
      show: false,
      toPageUrl: "",
      number: '',//输入金额
      ifClick: false,//是否可点击
      showBtn: true,//是否展示申请按钮
    };
  },
  created () {
    this.getTopInfo();
  },
  computed: {
    commonParams () {
      return this.$store.state.common.commonParams;
    },
  },
  mounted () {
    console.log(this.commonParams);
    this.util.title("新口子");
    this.getRecommend();
    let json = {
      event_key: "h5_loanmarket_view",
    };
    this.toCountPoint(json);
    let _this = this;
    _this.mescroll = new MeScroll("mescroll", {
      //请至少在vue的mounted生命周期初始化mescroll,以确保您配置的id能够被找到
      up: {
        auto: true,
        callback: _this.getScrollMethods, //上拉回调
        page: {
          size: 20,
        },
        clearEmptyId: "noticeList",
        offset: 10,
        noMoreSize: 3,
        htmlNodata: '<p class="upwarp-nodata"></p>',
        onScroll: function (mescroll, y, isUp) {
          _this.scrollTop = y - 220;
          _this.noticeScrollTop = _this.$refs.noticeList.offsetTop;

          _this.getWindowHeight =
            document.documentElement.clientHeight || document.body.clientHeight;
          // console.log(_this.getWindowHeight + "当前屏幕高度");
          // console.log(_this.scrollTop + "当前滚动条据顶部的距离");
          // console.log(_this.noticeScrollTop + "下拉列表距离顶部高度");
          // console.log(_this.productDetails)
          clearTimeout(_this.timer);
          _this.t1 = _this.exposure();
          _this.timer = setTimeout(_this.isScrollEnd, 500);
        },
      },
      down: {
        auto: false, //自动加载
        isBounce: false,
        callback: _this.downCallback,
      },
    });
  },
  methods: {
    getScrollMethods (page) {
      this.getTopInfo();
      this.getList(page);
    },
    getTopInfo () {
      this.$get("/app/api/v2/home/dae/button")
        .then((res) => {
          console.log(res)
          if (res.code == 200) {
            this.showBtn = res.data == true ? true : false;
          } else {
            this.util.toast({ msg: res.message });
          }
        })
        .catch((error) => {
          console.log("error");
        });
    },
    tomember () {
      window.location.href = this.toPageUrl;
      this.show = false;
    },
    //统计埋点
    toCountPoint (json) {
      this.$get("/app/api/v1/newEventTrace", json)
        .then((res) => {
          if (res.code == 200) {
          } else {
            this.util.toast({ msg: res.message });
          }
        })
        .catch((error) => { });
    },
    bannerClick () {
      this.countClickRate(this.appAdvertisementResp[0], 7, 'new');
    },
    bannerClickMore () {
      this.countClickRate(this.appAdvertisementResp[1], 7, 'new');
    },
    listClick (item, pagePosition) {
      this.toPageUrl = item.pageUrl;
      let json = {
        event_key: "h5_loanmarket_products_click",
        product_id: item.id,
        product_type: item.type,
      };
      this.toCountPoint(json);
      this.countClickRate(item, pagePosition, 'new');
    },
    numJewelsInStones (J, S) {
      //S按字母拆成数组，把J里包含的字母留下来，数组长度就是答案
      return S.split("").filter(function (i, index) {
        (i) => J.includes(i);
      }).length;
    },
    //获取跳转链接
    getPageUrl (item, pagePosition, txt) {
      let param = {};
      param.productId = this.obj.productId;
      param.pagePosition = pagePosition;
      this.obj.sign = this.obj.productId + "zEf8JalypwrJAvWYbXYnvBfltrbL2Q";
      param.sign = this.$md5(this.obj.sign);
      let _this = this;
      console.log(txt)
      this.$post("/app/api/v1/getUrl", param)
        .then(function (res) {
          if (res.code == 200) {
            let href = _this.util.decrypt(res.data); //对返回值进行解密
            //去前筛
            if (item.isFilter == 1 && item.hasMoney == 0) {
              _this.getFileter(item, JSON.parse(href).url);
            } else {
              if (txt == 'new') {
                let json = {
                  event_key: "h5_webview",
                  os: localStorage.getItem("os"),
                  app_market_channel: localStorage.getItem("appMarketChannel"),
                  app_version: localStorage.getItem("appVersion"),
                  customer_id: localStorage.getItem("customerId"),
                  udid: localStorage.getItem("udid"),
                  package_name: localStorage.getItem("packageName"),
                  url: JSON.parse(href).url,
                };
                _this.toCountPoint(json);
              }
              window.location.href = JSON.parse(href).url;
            }
            console.log(JSON.parse(href).url);
          } else {
            this.util.toast({ msg: res.message });
          }
        })
        .catch(function (error) { });
    },
    isScrollEnd () {
      this.t2 = this.exposure();
      if (this.t2 === this.t1) {
        // 调用曝光接口
        console.log("滚动结束了——————————调用曝光接口" + this.productIds);

        console.log("滚动结束了——————————调用曝光接口" + this.productTypes);
        let param = {
          num: 1,
          product_id: this.productIds,
          product_type: this.productTypes,
          event_key: "h5_loanmarket_products_view",
        };
        this.$post("/app/api/v1/newExposure", param)
          .then(function (res) {
            if (res.code == 200) {
              console.log(res);
            } else {
              _this.util.toast({ msg: res.message });
            }
          })
          .catch(function (error) { });
      }
    },
    exposure () {
      this.productIds = "";
      this.productTypes = "";
      // 计算曝光量
      // 偏移量：scrollTop  屏幕高度：getWindowHeight   列表距离顶部的高度：noticeScrollTop   每条数据高度：100
      // 当偏移量<=列表距离顶部的高度——————没有分页的情况时
      //100是每条记录的高度
      let upIndex = 0; //上标
      let downIndex = 0; //下标
      if (this.scrollTop <= this.noticeScrollTop) {
        downIndex =
          Math.round(
            (this.getWindowHeight - (this.noticeScrollTop - this.scrollTop)) /
            75
          ) - 1;
      } else {
        upIndex = Math.round((this.scrollTop - this.noticeScrollTop) / 75);
        downIndex =
          Number(
            Math.floor(
              (this.getWindowHeight + this.scrollTop - this.noticeScrollTop) /
              75
            )
          ) - 1;
      }
      for (let i = upIndex;i <= downIndex;i++) {
        if (i > this.productDetails.length - 1) {
          break;
        } else {
          this.productIds += this.productDetails[i].id + ",";
          this.productTypes += this.productDetails[i].type + ",";
        }
      }
    },
    /**
     * 下拉刷新
     */
    downCallback () {
      this.productDetails = []; //重置数组
      // this.getTopInfo();
      //下拉刷新的回调
      this.mescroll.resetUpScroll();
    },
    getList (page) {
      let _this = this;
      let params = {
        page: page.num, //从1开始
        size: _this.pageSize,
      };
      this.$get("/app/newWeb/v1/newTwo/products", params)
        .then(function (res) {
          if (res.code == 200) {
            //产品分页
            let productList = res.data.productDetails;
            _this.productDetails = _this.productDetails.concat(productList);
            _this.mescroll.endBySize(productList.length, res.data.total);
          } else {
            _this.util.toast({ msg: res.message });
          }
        })
        .catch(function (error) {
          console.log("错误");
        });
    },
    getRecommend () {
      let _this = this;
      this.$get("/app/newWeb/v1/newTwo/recommendAndAD")
        .then(function (res) {
          if (res.code == 200) {
            _this.appRecommendResps = res.data.appRecommendResps;
            _this.appAdvertisementResp = res.data.appAdvertisementResp;

            if (_this.appAdvertisementResp[0].imgUrl) {
              let json = {
                event_key: "h5_loanmarket_banner_view",
                url: _this.appAdvertisementResp[0].imgUrl,
              };
              _this.toCountPoint(json);
            }
            _this.imgUrl = _this.appAdvertisementResp[0].imgUrl;
            if (_this.appAdvertisementResp[1]) {
              _this.moreImgUrl = _this.appAdvertisementResp[1].imgUrl;
            }
            _this.status = _this.appAdvertisementResp[0].status;
          } else {
            _this.util.toast({ msg: res.message });
          }
        })
        .catch(function (error) {
          console.log("错误");
        });
    },
    //去跳转获取url
    countClickRate (item, pagePosition, txt) {
      //判断登录
      if (
        localStorage.getItem("token") == "undefined" ||
        localStorage.getItem("token") == "" ||
        localStorage.getItem("token") == null
      ) {
        //跳转到ios的登录页面
        this.toLogin();
      } else {
        if (item.hasMember || pagePosition == 7 || pagePosition == 6) {
          //是会员
          if (
            item.pageUrl == null ||
            item.pageUrl == undefined ||
            item.pageUrl == ""
          ) {
            //h5产品
            this.obj.productId = item.id;
            this.getPageUrl(item, pagePosition, txt);
          } else {
            //去前筛
            if (item.isFilter == 1 && item.hasMoney == 0) {
              this.getFileter(item, item.pageUrl);
            } else {
              window.location.href = item.pageUrl;
            }
          }
        } else {
          this.show = true;
        }
      }
    },
    //用户过滤接口
    getFileter (item, pageUrl) {
      let _this = this;
      this.$get("/app/api/v1/union/can-loan", {
        productId: item.id,
      })
        .then(function (res) {
          if (res.code == 200) {
            let json = {
              event_key: "h5_webview",
              os: localStorage.getItem("os"),
              app_market_channel: localStorage.getItem("appMarketChannel"),
              app_version: localStorage.getItem("appVersion"),
              customer_id: localStorage.getItem("customerId"),
              udid: localStorage.getItem("udid"),
              package_name: localStorage.getItem("packageName"),
              url: pageUrl,
            };
            _this.toCountPoint(json);
            window.location.href = pageUrl;
          } else if (res.code == 4101) {
            //实名认证未通过
            //跳转到ios的实名认证页面
            _this.authFail();
          } else if (res.code == 4103 || res.code == 4104) {
            //撞库、前筛未通过
            //跳转到ios的实名认证页面
            // _this.signInFail(item);
            window.location.href = res.data;
          } else {
            _this.util.toast({ msg: res.message });
          }
        })
        .catch(function (error) { });
    },
    //调用android和ios的方法
    authFail () {
      try {
        window.webkit.messageHandlers.authFail.postMessage(""); //ios
      } catch (err) {
        window.AppJs.authFail(); //android
      }
    },
    //调用android和ios的方法
    signInFail (item) {
      let json = {
        productId: item.id,
      };
      try {
        window.webkit.messageHandlers.signInFail.postMessage(json); //ios
      } catch (err) {
        window.AppJs.signInFail(JSON.stringify(json)); //android
      }
    },
    //去登录
    toLogin () {
      try {
        window.webkit.messageHandlers.toLogin.postMessage(""); //ios
      } catch (err) {
        window.AppJs.toLogin(); //android
      }
    },
    applyNum () {
      this.ifClick = this.number > 0 ? true : false;
    },
    toApplyPage () {
      if (this.ifClick) {
        try {
          window.webkit.messageHandlers.toLoan.postMessage(""); //ios
        } catch (err) {
          window.AppJs.toLoan(); //android
        }
      }
    }
  },
};
</script>
